import {Route, Switch, withRouter} from 'react-router-dom'
import {Slot} from 'react-slot-fill'
import {connect} from 'react-redux'
import React from 'react'
import classNames from 'classnames'
import styled from 'styled-components'

import {Icon, ContextMenu, Li, ListSeparator, Button, Popup, Link} from 'startlibs/lib/components'
import {getColor} from 'startlibs/lib/lib'
import {getFetcher} from 'startlibs'
import {withPopupToggles} from 'startlibs/lib/hocs'
import {getResource, queryHasValue} from './lib'
import load from 'little-loader'

const WistiaSpan = styled.span`
  a.styled-button.video-link {
    margin-top: .75rem;
  }
`

const ContextMenuHeader = styled.li`
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem 0.5rem 0.75rem;
  .user-info {
    display: inline-block;
    margin-left: 0.5rem;
  }
  .user-name {
    font-weight: 600;
    max-width: 13rem;
    display: flex;
    align-items: center;
    span {
      overflow: hidden;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .user-email {
    color: rgba(0,0,0,0.5);
    font-size: 11px;
  }
  .user-avatar {
    width: 2.75rem;
    height: 2.75rem;
    border-radius: 50%;
    background-color: ${getColor('gray240')};
    display: inline-block;
    overflow: hidden;
    img {
      width: 100%;
    }
  }
`
const ContextMenuFooter = styled.li`
  background-color: rgba(0,0,0,0.05);
  border-top: 1px solid rgba(0,0,0,0.05);
  margin-top: 0.5rem;
  margin-bottom: -0.5rem;
  padding: 6px 1rem 9px;
  font-size: 11px;
  color: rgba(0,0,0,0.5);
  a {
    line-height: 14px;
    display: inline-block;
    text-decoration: none;
    color: inherit;
    &:hover {
      color: ${getColor('main')};
      text-decoration: underline;
    }
  }
`

const TrialLabel = styled(Link)`
  background-color: ${getColor('main')};
  padding: 2px 0.5rem;
  border-radius: 3px;
  color: white;
  font-size: 11px;
  margin-top: -1px;
  text-decoration: none;
  margin-left: 0.25rem;
`

const CanceledLabel = styled(TrialLabel)`
  background-color: ${getColor('alert')};
`

@withRouter
@connect(({report, user}, {location}) => ({
  isReportPreviewOpen: (location.pathname.indexOf('/report/') >= 0 && report) ? report.isPreviewOpen || report.finished || report.readOnly : false,
  user: user
}))

@withPopupToggles('helpPopup', 'preferencesMenu')
export class Navbar extends React.PureComponent {

  componentDidMount() {
    load("https://fast.wistia.com/embed/medias/zb975x40on.jsonp")

    load("https://fast.wistia.com/assets/external/E-v1.js")
  }

  signOut = () => {
    localStorage.removeItem('hasLogged')
    getFetcher('/api/logout').then(() => window.location = '/')
  }

  getAvatarBackground = () => ({backgroundImage: 'url("' + getResource(this.props.user.picture || '/public/user-avatar.png') + '")'})

  render() {
    const {helpPopup, location, preferencesMenu, isReportPreviewOpen, user} = this.props
    const isEmbedded = queryHasValue(location.search,'embedded','true')
    return <div className={'navbar ' + (isEmbedded ? 'embedded-layout ' : 'browser-layout ') + (classNames(isReportPreviewOpen ? 'preview' : 'editor'))}>

      <div className="navbar-content">
          {
            !isEmbedded &&
            <div className="left-container logo-container">
              <React.Fragment>
                {user.id
                 ? <Link to="/" className="logo">Horos Cloud</Link>
                 : <Link skipTo="/" className="logo">Horos Cloud</Link>
                }
                <Switch>
                  <Route path="/report/:uid" render={() => null}/>
                  <Route path="/checkout" render={() => null}/>
                  <Route path="/first-steps" render={() => null}/>
                  <Route path="/storage/checkout" render={() => null}/>
                  <Route render={() => user.hasProfile && <div className="navbar-user-name-container"><span
                    className="navbar-user-name">{user.firstName} {user.lastName}</span></div>}/>
                </Switch>
              </React.Fragment>
            </div>
          }
        <Slot name="Navbar-Center"/>
        {!isEmbedded && (user.hasProfile ?
          <div className="right-container navbar-user-actions">
            <Switch>
              <Route path="/" exact render={()=>null}/>
              <Route render={()=> <Link className="navbar-icon-button" to="/"><Icon icon="home" className="icon"/></Link>}/>
            </Switch>
            <a className="navbar-icon-button" onClick={helpPopup.toggle}>
              <Icon icon="help" className="icon"/>
              {
                helpPopup.isOpen &&
                <Popup arrow offset="25 0" className="help-bubble">
                  <div className="bubble-title bold">Need help?</div>
                  <Button.a target="_blank" href="/first-steps" rel="noopener noreferrer">
                    First steps guide
                  </Button.a>
                  <Button.a target="_blank" href="https://info.horosproject.org/horos-cloud-faq" rel="noopener noreferrer">
                    Frequently Asked Questions
                  </Button.a>
                  <Button.a target="_blank" href="http://academy.horosproject.org/" rel="noopener noreferrer">
                    Learn with Horos Academy
                  </Button.a>
                  <WistiaSpan className="wistia_embed wistia_async_zb975x40on popover=true popoverContent=link">
                    <Button.a className="video-link" href="#">Check our video tutorial</Button.a>
                  </WistiaSpan>
                  <hr/>
                  <Button.a highlight target="_blank" href="https://horosproject.org/professional-support/"
                            rel="noopener noreferrer">
                    Get professional support
                  </Button.a>
                </Popup>
              }
            </a>
            <a className="user-menu" onClick={preferencesMenu.toggle}>
              <div className="user-avatar" style={this.getAvatarBackground()}></div>
              <span className="icon icon-arrow-down"></span>
              {
                preferencesMenu.isOpen &&
                <ContextMenu>
                  <ContextMenuHeader>
                    <div className="user-avatar" style={this.getAvatarBackground()}/>
                    <div className="user-info">
                      <div className="user-name">
                        <span>{user.firstName} {user.lastName}</span>
                        {user.accountStatus==="trialing" && !user.stripeCardAdded && <TrialLabel to="/checkout">Trial</TrialLabel>}
                        {user.accountStatus==="canceled" && user.stripeCardAdded && <CanceledLabel to="/checkout">Canceled</CanceledLabel>}
                      </div>
                      <div className="user-email">{user.email}</div>
                    </div>
                  </ContextMenuHeader>
                  <ListSeparator/>
                  <Li linkTo="/profile" icon="edit-box" label="Edit profile"/>
                  <Li skipTo="/account-settings" label="Account settings"/>
                  <Li linkTo="/workstations" label="Manage workstations"/>
                  <ListSeparator/>
                  <Li linkTo="/billing" icon="credit-card" label="Manage subscription"/>
                  <ListSeparator/>
                  <Li onClick={this.signOut} icon="sign-out" label="Sign out"/>
                  <ContextMenuFooter>
                    <a href="/license" target="_blank" rel="noopener noreferrer">License Terms</a> - <a
                    href="https://www.horosproject.org/" target="_blank" rel="noopener noreferrer">Horos Project</a>
                  </ContextMenuFooter>
                </ContextMenu>
              }
            </a>
          </div>
          : user.id &&
          <div className="right-container">
            <Button onClick={this.signOut} small outline white className="logout-button">Logout</Button>
          </div> )
        }
      </div>
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/javascripts/Navbar.jsx